import React, { useState, useRef } from 'react';
import { faArrowLeft, faArrowRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ImageGallery({item}) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const galleryRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % item.imageLinks.length);
    };

    const prevImage = () => {
        setCurrentImageIndex(
            (prevIndex) => (prevIndex - 1 + item.imageLinks.length) % item.imageLinks.length
        );
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.clientX);
        setScrollLeft(galleryRef.current.scrollLeft);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        const moveX = e.clientX - startX;
        galleryRef.current.scrollLeft = scrollLeft - moveX;
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleModalClick = (e) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    if(item.imageLinks.length === 0){
        return <div>{item.title}</div>
    }

    return (
        <div className="flex flex-col items-center space-y-4">
            {/* Голема слика */}
            <div className="w-full max-w-xs">
                <img
                    src={item.imageLinks[currentImageIndex].imageLink}
                    alt="Main"
                    className="w-full rounded-lg shadow-lg cursor-pointer"
                    onClick={() => setIsModalOpen(true)}
                />
            </div>

            {/* Small pictures- responsive */}
            <div
                ref={galleryRef}
                className="flex space-x-4 overflow-x-auto scrollbar-none w-full py-4 cursor-grab justify-center"
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
            >
                {item.imageLinks.map((image, index) => (
                    <img
                        key={index}
                        src={image.imageLink}
                        alt={`Thumbnail ${index}`}
                        onClick={() => setCurrentImageIndex(index)}
                        className={`w-24 h-24 object-cover cursor-pointer rounded-lg shadow-md transition-transform transform hover:scale-105 ${currentImageIndex === index ? 'border-2 border-blue-500' : ''
                            }`}
                    />
                ))}
            </div>

            {/* Modal for big picture */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50"
                     onClick={handleModalClick}>
                    <div className="relative bg-white p-6 rounded-lg shadow-xl w-4/5 max-w-2xl">
                        <img
                            src={item.imageLinks[currentImageIndex].imageLink}
                            alt="Main"
                            className="w-full max-h-[30rem] object-contain"
                        />
                        <div className="absolute top-1/2 left-0 transform -translate-y-1/2 px-4">
                            <button
                                onClick={prevImage}
                                className="btn btn-circle btn-primary text-white"
                            >
                                <FontAwesomeIcon className='text-3xl' icon={faArrowLeft} />
                            </button>
                        </div>
                        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 px-4">
                            <button
                                onClick={nextImage}
                                className="btn btn-circle btn-primary text-white"
                            >
                                <FontAwesomeIcon className='text-3xl' icon={faArrowRight} />
                            </button>
                        </div>
                        <button
                            onClick={closeModal}
                            className="absolute top-0 right-0 p-4 text-black text-xl"
                        >
                            &#10005;
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ImageGallery
